<template>
  <div
    v-if="isShowPpc"
    :class="{'hide': !showBanner, 'ppc-wrapper': !isProductPerksEnabled}"
  >
    <PpcContent
      v-bind="ppcProps"
      :is-perks-placement="isPerksPlacement"
      @openPpcModal="openPpcModal"
      @openDetailsModal="openDetailModal"
      @toggleBanner="togglePpc"
    >
      <template #loyalty-icon="{ iconClass = '' }">
        <div class="loyalty-icon-wrapper cell margin-right-xxs">
          <i
            v-if="!!ppcIconName"
            :class="[ppcIconName, iconClass]"
          />
        </div>
      </template>
    </PpcContent>

    <component
      :is="ActiveModal"
      v-if="!!ActiveModal"
      v-bind="{ badgesList, name: `${modalName}-modal`,'modal-details': modalProps }"
      @close="modalName = ''"
    />
  </div>
</template>

<script setup>
import {
  ref, computed, defineAsyncComponent, watchEffect,
} from 'vue';
import { fireDetailsAnalytics } from '@common-vue/media-card-large/src/modules/price/components/utils.common';

import { useEnvProps } from '@composables/useEnvProps';
import { useModal } from '@composables/utils/useModal';
import { usePpc } from '@modules/ppc/composables';
import { useFeatureEligibility } from '@modules/featureControl';
import once from '@utils/once';
import { ppcDetailsClicked } from '../../../features/analytics/productPerks';

const props = defineProps({
  priceId: {
    type: String,
    default: '',
  },
  priceOfferDescription: {
    type: String,
    default: '',
  },
  badgesList: {
    type: Array,
    default: () => [],
  },
  isPerksPlacement: {
    type: Boolean,
    default: false,
  },
});

const PPC_MODAL = 'ppc';
const PRICE_DETAILS_MODAL = 'price-details';

const { brand } = useEnvProps();
const { open } = useModal();
const {
  ppcProps,
  modalProps,
  ppcIconName,
  isShowPpc,
} = usePpc();
const { isProductPerksEnabled } = useFeatureEligibility();
const firePerksAnalytics = once(ppcDetailsClicked);

// @todo - combine with 'isShowPpc' later
const showBanner = ref(true);

const modalName = ref('');

const PpcContent = defineAsyncComponent(() => import(/* webpackChunkName: "PpcContent" */ `./${brand}/PPC.${brand}`));

const Modals = {
  [PRICE_DETAILS_MODAL]: defineAsyncComponent(() => import(/* webpackChunkName: 'DetailsModal bcom' */ '@common-vue/media-card-large/src/modules/price/components/DetailsModal')),
  [PPC_MODAL]: defineAsyncComponent(() => import(/* webpackChunkName: 'PpcModal' */'./PpcModal')),
};
const ActiveModal = computed(() => Modals[modalName.value]);

const togglePpc = (toggle) => {
  showBanner.value = toggle;
};

const openPpcModal = () => {
  if (isProductPerksEnabled) {
    firePerksAnalytics();
  }
  modalName.value = PPC_MODAL;
};

const openDetailModal = () => {
  fireDetailsAnalytics({
    id: props.priceId,
    value: props.priceOfferDescription,
  });
  modalName.value = PRICE_DETAILS_MODAL;
};

watchEffect(() => {
  const name = modalName.value;

  if (name === PPC_MODAL || name === PRICE_DETAILS_MODAL) {
    open(`${name}-modal`);
  }
});
</script>
<style lang="scss" brand="bcom" scoped>
@import "~settingSCSS";

.ppc-wrapper:not(.hide):has(+ .label) {
  @include margin-direction('bottom', map-get($spacer, 'xs'));
}
</style>
<style lang="scss" scoped>
.loyalty-icon-wrapper {
  max-width: 24px;
  max-height: 24px;
  // mcom only
  .star-rewards-icon {
    display: flex;
    flex-shrink: 0;
  }
}
</style>
